import { render, staticRenderFns } from "./InformationBox.vue?vue&type=template&id=10aac934&scoped=true&"
import script from "./InformationBox.vue?vue&type=script&lang=ts&"
export * from "./InformationBox.vue?vue&type=script&lang=ts&"
import style0 from "./InformationBox.vue?vue&type=style&index=0&id=10aac934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aac934",
  null
  
)

export default component.exports